import React from 'react';
import { TrendingUpIcon, ZapIcon, MapPinIcon } from 'lucide-react';
export function CaseStudySection() {
  return <section className="py-12 relative" data-id="element-260">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-261">
        <div className="relative rounded-2xl p-1 bg-gradient-to-b from-cyan-500/30 to-transparent" data-id="element-262">
          <div className="bg-dark-950 rounded-xl p-8 md:p-12 relative overflow-hidden" data-id="element-263">
            {/* Background pattern */}
            <div className="absolute inset-0 opacity-5" style={{
            backgroundImage: 'radial-gradient(#00f0ff 1px, transparent 1px)',
            backgroundSize: '20px 20px'
          }} data-id="element-264"></div>

            <div className="relative z-10" data-id="element-265">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8" data-id="element-266">
                <div className="flex items-center gap-2 text-cyan-400 font-mono text-sm" data-id="element-267">
                  <ZapIcon className="w-4 h-4" data-id="element-268" />
                  <span data-id="element-269">SYSTEM_LOG: SUCCESS_STORY</span>
                </div>
                <div className="flex items-center gap-2 text-gray-400 text-xs font-bold tracking-widest uppercase bg-dark-900 px-3 py-1.5 rounded-full border border-gray-800" data-id="element-270">
                  <MapPinIcon className="w-3.5 h-3.5" data-id="element-271" />
                  <span data-id="element-272">NEW YORK CITY — 19 DAYS AGO</span>
                </div>
              </div>

              <blockquote className="border-l-4 border-cyan-400 pl-6 py-2 mb-10" data-id="element-273">
                <p className="text-2xl md:text-3xl italic text-white font-light leading-relaxed" data-id="element-274">
                  "Zero to $7,500/Month. No code. No team. No agency experience.
                  Just the stack."
                </p>
              </blockquote>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10" data-id="element-275">
                <div className="bg-dark-900 border border-cyan-900/30 rounded-xl p-6 text-center flex flex-col justify-center" data-id="element-276">
                  <span className="text-4xl md:text-5xl font-bold text-cyan-400 mb-2" data-id="element-277">
                    3
                  </span>
                  <span className="text-sm text-gray-400 font-medium uppercase tracking-wider" data-id="element-278">
                    Clients Signed
                  </span>
                </div>
                <div className="bg-dark-900 border border-cyan-900/30 rounded-xl p-6 text-center flex flex-col justify-center" data-id="element-279">
                  <span className="text-4xl md:text-5xl font-bold text-cyan-400 mb-2" data-id="element-280">
                    $2,500
                  </span>
                  <span className="text-sm text-gray-400 font-medium uppercase tracking-wider" data-id="element-281">
                    Per Month Each
                  </span>
                </div>
                <div className="bg-dark-900 border border-cyan-900/30 rounded-xl p-6 text-center flex flex-col justify-center" data-id="element-282">
                  <span className="text-4xl md:text-5xl font-bold text-cyan-400 mb-2" data-id="element-283">
                    19
                  </span>
                  <span className="text-sm text-gray-400 font-medium uppercase tracking-wider" data-id="element-284">
                    Days Total
                  </span>
                </div>
              </div>

              <div className="space-y-2 text-xl text-center mt-8" data-id="element-285">
                <p className="text-gray-300" data-id="element-286">He didn't learn to code.</p>
                <p className="text-gray-300" data-id="element-287">He learned to Connect.</p>
                <p className="text-cyan-400 font-bold text-2xl mt-4 text-glow" data-id="element-288">
                  He became the Architect.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}